import { ComponentProps, FC } from 'react';

export const DownwardArrowIcon: FC<ComponentProps<'svg'>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      {...props}
    >
      <path
        d="M16.8527 20.9421C16.8527 17.8051 16.8491 14.8672 16.8549 11.9292C16.8567 11.0736 17.3415 10.5508 18.0965 10.5544C18.8479 10.558 19.3206 11.0813 19.3224 11.944C19.3273 14.6588 19.3242 17.3731 19.3242 20.0874C19.3242 20.3083 19.3242 20.5297 19.3242 20.9273C20.0469 20.2055 20.6606 19.5914 21.2746 18.9782C21.551 18.7027 21.8154 18.412 22.1101 18.1571C22.6414 17.6969 23.3731 17.7295 23.8329 18.2103C24.2743 18.6714 24.3025 19.3866 23.8481 19.8879C23.3646 20.4201 22.8396 20.9143 22.3306 21.4233C21.2697 22.4855 20.2111 23.55 19.1448 24.6063C18.3917 25.3528 17.7803 25.3506 17.0217 24.5961C15.5346 23.117 14.0525 21.6326 12.5712 20.1473C11.9043 19.4787 11.826 18.7398 12.3547 18.1996C12.8878 17.6544 13.6383 17.7197 14.3011 18.3794C15.1129 19.188 15.9184 20.0029 16.8527 20.9421Z"
        fill="#FF5000"
      />
      <path
        d="M18.5 2.68346C9.77865 2.68346 2.68349 9.77853 2.68349 18.4998C2.68349 27.221 9.77865 34.3165 18.5 34.3165C27.2214 34.3165 34.3165 27.221 34.3165 18.4998C34.3165 9.77853 27.2214 2.68346 18.5 2.68346ZM18.5 37C8.29915 37 0 28.7005 0 18.4998C0 8.29905 8.29915 0 18.5 0C28.7009 0 37 8.29905 37 18.4998C37 28.7005 28.7009 37 18.5 37Z"
        fill="#FF5000"
      />
    </svg>
  );
};
